export default "__VITE_ASSET__67631e13__"